module.exports = {
  "marketName": "UK",
  "marketNameTracking": "UK",
  "locale": "en-GB",
  "pregnancyCTAUrl": "https://www.slimmingworld.co.uk/mums",
  "supportEmail": "online.support@slimmingworld.co.uk",
  "currencyCode": "GBP",
  "digitalSupportTeamPhoneNumber": "0344 892 0430",
  "technicalMemberSupportPhoneNumber": "0344 892 0431",
  "defaultCountry": "GB",
  "textBasedGroupSearch": true,
  "dropDownBasedGroupSearch": false,
  "voucherPhoneNumber": "0344 892 0400",
  "groupEnquiriesNumber": "0344 897 8000",
  "headOfficeNumber": "0344 892 0400",
  "hasGeolocationGroupSearch": true,
  "offerRoundels": false
};